import { useApolloClient, useMutation } from '@apollo/react-hooks';
import { USER_LOGOUT } from '../const/mutations';
import { useNavigate } from 'react-router-dom';

export const useLogout = (callback?: () => void) => {
    const navigate = useNavigate();
    const client = useApolloClient();

    return useMutation(USER_LOGOUT, {
        onCompleted() {
            if (callback) {
                callback();
            }
            localStorage.removeItem('user');
            client.writeData({ data: { isLoggedIn: false, user: null } });
            client.resetStore();
            navigate('/developer');
        },
    });
};
